<template>
	<component :is="icon" :stroke-width="1.5"/>
</template>

<script>
import {
	IconFileTypeBmp,
	IconFileTypeCss,
	IconFileTypeCsv,
	IconFileTypeDoc,
	IconFileTypeDocx,
	IconFileTypeHtml,
	IconFileTypeJpg,
	IconFileTypeJs,
	IconFileTypePdf,
	IconFileTypePhp,
	IconFileTypePng,
	IconFileTypePpt,
	IconFileTypeSvg,
	IconFileTypeTs,
	IconFileTypeTxt,
	IconFileTypeXls,
	IconFileTypeXml,
	IconFileTypeZip,
	IconFileUnknown,
} from "@tabler/icons-vue";

export default {
	name: "FileTypeIcon",
	components: {
		IconFileTypeBmp,
		IconFileTypeCss,
		IconFileTypeCsv,
		IconFileTypeDoc,
		IconFileTypeDocx,
		IconFileTypeHtml,
		IconFileTypeJpg,
		IconFileTypeJs,
		IconFileTypePdf,
		IconFileTypePhp,
		IconFileTypePng,
		IconFileTypePpt,
		IconFileTypeSvg,
		IconFileTypeTs,
		IconFileTypeTxt,
		IconFileTypeXls,
		IconFileTypeXml,
		IconFileTypeZip,
		IconFileUnknown,
	},
	props: {
		mimeType: {
			type: String,
			required: true,
		},
	},
	computed: {
		icon() {
			return {
				'image/bmp': IconFileTypeBmp,
				'text/css': IconFileTypeCss,
				'text/csv': IconFileTypeCsv,
				'application/msword': IconFileTypeDoc,
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document': IconFileTypeDocx,
				'text/html': IconFileTypeHtml,
				'image/jpeg': IconFileTypeJpg,
				'text/javascript': IconFileTypeJs,
				'application/pdf': IconFileTypePdf,
				'application/x-httpd-php': IconFileTypePhp,
				'image/png': IconFileTypePng,
				'application/vnd.ms-powerpoint': IconFileTypePpt,
				'image/svg+xml': IconFileTypeSvg,
				'video/mp2t': IconFileTypeTs,
				'text/plain': IconFileTypeTxt,
				'application/vnd.ms-excel': IconFileTypeXls,
				'application/xml': IconFileTypeXml,
				'text/xml': IconFileTypeXml,
				'application/zip': IconFileTypeZip,
			}[this.mimeType] || IconFileUnknown;
		}
	},
}
</script>

<style scoped>

</style>